/*=========================================================================================
  File Name: module-usertax-getters.js
  Description: UserTax Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
  LayoutInfos(state) {
    return state.LayoutInfos;
  }
};
